/**
 * bubu-regalo.js — popup «¿Quieres un Slime Gratis?» (prototipo · Popups).
 *
 * Se abre:
 *   - solo, a los N segundos (ajuste del tema), una vez por visitante. No sale:
 *       · a quien ya se apuntó (marca 'ok');
 *       · a la clienta con sesión que YA acepta emails (data-cliente, desde Liquid);
 *       · a quien Klaviyo ya tiene identificado (klaviyo.isIdentified(), con tope de
 *         2,5 s para no depender de un tercero lento), como en v12;
 *       · si la visita llegó desde un email (URL con regalo= o _kx=): en toda esa
 *         visita, gracias a la marca de sesión «bubu:vino-con-regalo».
 *     En esos casos no se marca «visto»: simplemente no se abre solo;
 *   - siempre que se pulsa «Slime gratis» en la cabecera (evento bubu:regalo).
 *
 * SOLO CON EL FORMULARIO PINTADO (v13). El formulario lo pinta Klaviyo con decenas de
 * archivos suyos; con datos móviles, en el navegador de Instagram o con bloqueadores
 * puede tardar mucho o no llegar. Antes el popup se abría a los 3 s igualmente: salía
 * sin campo ni botón, se marcaba «visto» y esa persona no lo volvía a ver nunca.
 * Ahora, a los 3 s:
 *   - si el formulario ya está, se abre;
 *   - si no, se espera en esa página hasta 10 s más;
 *   - si sigue sin estar, NO se abre ni se marca «visto»: se reintenta en la siguiente
 *     página que visite.
 * Al pulsar el botón de la cabecera se abre siempre, con «Cargando…» en el hueco del
 * formulario hasta que Klaviyo lo pinte.
 *
 * MEDICIÓN (v13). Cada caso manda un evento, como evento de cliente de Shopify
 * (Shopify.analytics.publish, para un píxel personalizado si algún día hace falta) y a
 * Google Analytics 4 (G-YWSHSKZ2ED), que es donde se leen por día:
 *   bubu_popup_abierto         se abrió (modo auto o manual; segundos_formulario =
 *                              cuándo pintó Klaviyo el formulario, observado desde que
 *                              arranca este archivo, en s desde el inicio de la página)
 *   bubu_popup_sin_formulario  tocaba abrirse solo y no se abrió porque no cargó
 *   bubu_popup_enviado         se apuntó en el formulario del popup
 *
 * ALTA DEL EMAIL (07/10/2026): la hace el formulario incrustado de Klaviyo (UJxDAf),
 * que Klaviyo pinta dentro de <div class="klaviyo-form-UJxDAf">. Este archivo no envía
 * nada: escucha el evento `klaviyoForms` y, cuando ese formulario se envía, enseña el
 * paso 2 («¡Enhorabuena!»).
 *
 * En localStorage solo guarda si ya se mostró/apuntó, para no repetirlo.
 */
const LLAVE = 'bubu:regalo';
const FORM_ID = 'UJxDAf';
const GA4 = 'G-YWSHSKZ2ED';
const ESPERA_EXTRA = 10000; // apertura sola: lo que se espera al formulario tras los 3 s
const ESPERA_MANUAL = 20000; // botón de la cabecera: tras esto, «no ha podido cargar»
const capa = () => document.getElementById('bubu-regalo');

/* Cuándo pintó Klaviyo el formulario, en ms desde que empezó a cargar la página. */
let pintadoEn = null;
const avisos = [];

function segundos(ms) {
  return Math.round(ms / 100) / 10;
}

/* Mide sin romper nada: si Shopify o Google no están (bloqueador), no pasa nada. */
function registra(nombre, datos) {
  const d = Object.assign({ pagina: location.pathname }, datos || {});
  try {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(nombre, d);
    }
  } catch (e) {
    /* sin eventos de cliente: seguimos */
  }
  try {
    if (typeof window.gtag === 'function') window.gtag('event', nombre, Object.assign({ send_to: GA4 }, d));
  } catch (e) {
    /* sin Google Analytics: seguimos */
  }
}

function formListo(el) {
  return !!(el && el.querySelector('.klaviyo-form-UJxDAf input'));
}

/* Vigila el hueco del formulario desde que arranca la página y apunta el momento exacto
   en que Klaviyo mete el campo, aunque nadie lo esté esperando todavía. */
function vigilaPintado(el) {
  if (formListo(el)) {
    yaPintado();
    return;
  }
  const hueco = el.querySelector('.klaviyo-form-UJxDAf');
  if (!hueco || !('MutationObserver' in window)) return;
  const obs = new MutationObserver(() => {
    if (!formListo(el)) return;
    obs.disconnect();
    yaPintado();
  });
  obs.observe(hueco, { childList: true, subtree: true });
}

/* ¿Klaviyo ya conoce a este visitante? Si su script tarda o falla, se responde «no»
   a los 2,5 s para no quedarse sin popup por un tercero lento. (Igual que en v12.) */
function klaviyoLoConoce() {
  const k = window.klaviyo;
  if (!k || typeof k.isIdentified !== 'function') return Promise.resolve(false);
  return Promise.race([
    Promise.resolve(k.isIdentified()).then((v) => v === true).catch(() => false),
    new Promise((r) => setTimeout(() => r(false), 2500)),
  ]);
}

/* ¿Llega desde un email? (enlace de regalo o enlace con identificador de Klaviyo)
   OJO: ?regalo= lo consume y lo BORRA de la barra de direcciones bubu-cart.js
   (Canjes.desdeUrl, con history.replaceState) antes de que este archivo mire, así que
   location no sirve. Se mira también la URL con la que se abrió de verdad la página
   (performance → navigation), que replaceState no toca. Si trae regalo= o _kx=, se deja
   la marca «bubu:vino-con-regalo» en sessionStorage y vale para toda la visita. */
const MARCA_EMAIL = 'bubu:vino-con-regalo';
function vieneDeEmail() {
  try {
    if (sessionStorage.getItem(MARCA_EMAIL) === '1') return true;
  } catch (e) {
    /* modo privado: se mira solo la URL */
  }
  const urls = [location.href];
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.name) urls.push(nav.name);
  } catch (e) {
    /* navegador sin esa API: se queda con location */
  }
  const si = urls.some((u) => {
    try {
      const q = new URL(u).searchParams;
      return q.has('regalo') || q.has('_kx');
    } catch (e) {
      return false;
    }
  });
  if (si) {
    try {
      sessionStorage.setItem(MARCA_EMAIL, '1');
    } catch (e) {
      /* modo privado: solo vale para esta página */
    }
  }
  return si;
}

function yaPintado() {
  if (pintadoEn === null) pintadoEn = performance.now();
  avisos.splice(0).forEach((f) => f());
}

/* Promesa: true en cuanto el formulario esté pintado; false si pasan `ms` sin él. */
function esperaFormulario(el, ms) {
  if (formListo(el)) {
    yaPintado();
    return Promise.resolve(true);
  }
  return new Promise((resolve) => {
    let hecho = false;
    let obs = null;
    const fin = (ok) => {
      if (hecho) return;
      hecho = true;
      if (obs) obs.disconnect();
      clearTimeout(reloj);
      resolve(ok);
    };
    const reloj = setTimeout(() => {
      if (formListo(el)) yaPintado();
      fin(formListo(el));
    }, ms);
    avisos.push(() => fin(true));
    const hueco = el.querySelector('.klaviyo-form-UJxDAf');
    if (hueco && 'MutationObserver' in window) {
      obs = new MutationObserver(() => {
        if (formListo(el)) {
          yaPintado();
          fin(true);
        }
      });
      obs.observe(hueco, { childList: true, subtree: true });
    }
  });
}

function marca(valor) {
  try {
    localStorage.setItem(LLAVE, valor);
  } catch (e) {
    /* modo privado: no pasa nada, solo se volverá a ver */
  }
}
function marcado() {
  try {
    return localStorage.getItem(LLAVE);
  } catch (e) {
    return null;
  }
}

function paso1(el) {
  el.classList.remove('is-ok');
  el.querySelector('[data-regalo-p1]').hidden = false;
  el.querySelector('[data-regalo-p3]').hidden = true;
}

function paso3(el) {
  if (!el) return;
  el.classList.add('is-ok');
  el.querySelector('[data-regalo-p1]').hidden = true;
  el.querySelector('[data-regalo-p3]').hidden = false;
}

/* Eventos del formulario de Klaviyo: pintado («embedOpen») y alta («submit», paso 2). */
window.addEventListener('klaviyoForms', (e) => {
  if (!e.detail || e.detail.formId !== FORM_ID) return;
  if (e.detail.type === 'embedOpen') yaPintado();
  if (e.detail.type === 'submit') {
    marca('ok');
    paso3(capa());
    registra('bubu_popup_enviado');
  }
});

function arranca() {
  const el = capa();
  if (!el) return;
  const mas = el.querySelector('[data-regalo-mas]');
  const legal = el.querySelector('[data-regalo-legal]');

  /* ---------- El teclado del móvil no puede partir el popup ----------
     En iOS, abrir el teclado NO encoge la ventana: `100dvh` sigue midiendo la pantalla
     entera, así que el panel se quedaba con su alto de siempre y el botón —lo único que
     hay que pulsar— acababa por debajo del teclado. El único que sabe de verdad cuánto
     se ve es visualViewport, así que la capa se ata a él: alto y desplazamiento en dos
     variables de CSS, medidas en el momento.

     Aquí NO se aprieta nada: lo que sobra se quita, por escalones y solo los que hagan
     falta (la foto y la chapa, luego el párrafo, luego los checks), y todo vuelve solo
     al cerrar el teclado. Lo poco que aún pueda sobrar se desplaza por el hueco vacío
     de encima del titular, para no serrar una línea de texto. Con scrollTop, no con
     scrollIntoView. */
  const panel = el.querySelector('[data-regalo-panel]');
  const vv = window.visualViewport;
  if (vv) {
    let pedido = false;
    const mide = () => {
      pedido = false;
      if (el.hidden) return;
      el.style.setProperty('--bubu-vv-h', Math.round(vv.height) + 'px');
      el.style.setProperty('--bubu-vv-top', Math.round(vv.offsetTop) + 'px');
      // 120 px de margen: la diferencia entre la ventana y lo que se ve solo pasa de
      // ahí cuando hay teclado (las barras del navegador no llegan a tanto).
      const teclado = window.innerHeight - vv.height > 120;
      el.classList.toggle('is-teclado', teclado);
      if (!panel) return;
      el.classList.remove('is-teclado-corto', 'is-teclado-minimo');
      if (teclado) {
        for (const nivel of ['is-teclado-corto', 'is-teclado-minimo']) {
          if (panel.scrollHeight <= panel.clientHeight + 6) break;
          el.classList.add(nivel);
        }
      }
      if (teclado) panel.scrollTop = panel.scrollHeight;
    };
    const pide = () => {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(mide);
    };
    vv.addEventListener('resize', pide);
    vv.addEventListener('scroll', pide);
    new MutationObserver(pide).observe(el, { attributes: true, attributeFilter: ['hidden'] });
    // El campo de email ahora lo pinta Klaviyo: se escucha cualquier foco dentro del
    // panel. iOS levanta el teclado con retardo, así que se vuelve a medir después.
    if (panel) panel.addEventListener('focusin', () => setTimeout(pide, 320));
    pide();
  }

  if (mas && legal) {
    mas.addEventListener('click', () => {
      const abierto = legal.hidden;
      legal.hidden = !abierto;
      mas.setAttribute('aria-expanded', String(abierto));
      mas.textContent = abierto ? 'Ver menos' : 'Ver más';
    });
  }

  // Desde ya se vigila cuándo pinta Klaviyo el formulario (para segundos_formulario).
  // Si ya estaba pintado antes de que llegara este archivo, se apunta este momento.
  vigilaPintado(el);

  // La cabecera («Slime gratis») pide abrirlo: siempre se abre, aunque ya se viera. Si
  // el formulario aún no está, «Cargando…» en su hueco hasta que llegue.
  const cargando = el.querySelector('[data-regalo-cargando]');
  const cargandoTexto = el.querySelector('[data-regalo-cargando-t]');
  document.addEventListener('bubu:regalo', () => {
    const apuntada = marcado() === 'ok';
    if (!apuntada) paso1(el);
    const listo = formListo(el);
    if (!apuntada && !listo) {
      el.classList.add('is-cargando');
      if (cargandoTexto) cargandoTexto.textContent = 'Cargando…';
      if (cargando) cargando.hidden = false;
      esperaFormulario(el, ESPERA_MANUAL).then((ok) => {
        if (ok) {
          el.classList.remove('is-cargando');
          if (cargando) cargando.hidden = true;
        } else if (cargandoTexto) {
          cargandoTexto.textContent = 'No ha podido cargar. Recarga la página para intentarlo de nuevo.';
        }
      });
    }
    el.abrir();
    registra('bubu_popup_abierto', {
      modo: 'manual',
      formulario: apuntada ? 'apuntada' : listo ? 'si' : 'cargando',
      segundos_formulario: pintadoEn === null ? undefined : segundos(pintadoEn),
    });
  });

  // Se mira siempre (no solo si toca abrir) para que la marca de visita quede puesta
  // desde la primera página de la visita.
  const desdeEmail = vieneDeEmail();

  // Apertura sola: activada en ajustes, no vista antes, no es clienta que ya acepta
  // emails, no llega desde un email, Klaviyo no la conoce y SOLO con el formulario pintado.
  if (el.dataset.auto && !marcado() && !el.dataset.cliente && !desdeEmail && !window.Shopify?.designMode) {
    const espera = Math.max(0, Number(el.dataset.espera || 3)) * 1000;
    setTimeout(async () => {
      if (marcado() || !el.hidden) return;
      if (await klaviyoLoConoce()) return;
      if (marcado() || !el.hidden) return;
      const listo = await esperaFormulario(el, ESPERA_EXTRA);
      // Mientras se esperaba pudo abrirlo a mano o apuntarse: entonces nada.
      if (marcado() || !el.hidden) return;
      if (!listo) {
        // Sin formulario no se abre ni se marca: se reintenta en la siguiente página.
        registra('bubu_popup_sin_formulario', { segundos_espera: segundos(performance.now()) });
        return;
      }
      marca('visto');
      paso1(el);
      el.abrir();
      registra('bubu_popup_abierto', { modo: 'auto', formulario: 'si', segundos_formulario: segundos(pintadoEn) });
    }, espera);
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
else arranca();
